<template>
  <PageLayout>
    <template v-slot:header>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <Breadcrumb>
              <div class="active section">
                <div class="neutral">Contratos</div>
              </div>
            </Breadcrumb>
          </div>
        </div>
      </div>
    </template>
    <template v-slot:main>
      <div class="ui padded grid">
        <div class="row">
          <div class="sixteen wide column">
            <form @submit.prevent="search()" class="ui small form search-form">
              <div class="fields">
                <div v-if="enableCardNumber" class="two wide field">
                  <label for="contract-search-card-number">
                    Número do cartão
                  </label>
                  <input
                    v-focus
                    type="text"
                    name="contract-search-card-number"
                    v-model="searchForm.card_number"
                  />
                </div>
                <div class="two wide field">
                  <label for="contract-search-cod">Código</label>
                  <input
                    v-focus
                    type="text"
                    name="contract-search-cod"
                    v-model="searchForm.cod"
                  />
                </div>
                <div class="six wide field">
                  <label for="contract-search-description">
                    Nome ou CPF do titular
                  </label>
                  <input
                    type="text"
                    name="contract-search-description"
                    v-model="searchForm.description"
                  />
                </div>
                <div class="six wide field">
                  <label for="contract-search-member">
                    Nome do beneficiário
                  </label>
                  <input
                    type="text"
                    name="contract-search-member"
                    v-model="searchForm.member"
                  />
                </div>
              </div>
              <div class="fields">
                <div class="three wide field">
                  <label for="contrato-search-plan">Plano</label>
                  <select
                    id="contrato-search-plan"
                    name="plan"
                    v-model="searchForm.plan_id"
                  >
                    <option :value="null"></option>
                    <option
                      v-for="(plan, index) in plans"
                      :key="index"
                      :value="plan.id"
                    >
                      {{ plan.id }} - {{ plan.description }}
                    </option>
                  </select>
                </div>
                <div class="three wide field">
                  <label for="contract-search-description">
                    Condição de Pagamento
                  </label>
                  <select
                    id="contrato-search-payment"
                    name="payment"
                    v-model="searchForm.payment_method"
                  >
                    <option :value="null"></option>
                    <option
                      v-for="(paymentMethod, index) in paymentMethods"
                      :key="index"
                      :value="paymentMethod.name"
                    >
                      {{ paymentMethod.description }}
                    </option>
                  </select>
                </div>
                <div class="three wide field">
                  <label for="users-rule">Situação</label>
                  <select id="users-rule" v-model="searchForm.state">
                    <option :value="null">Todos</option>
                    <option
                      v-for="(rule, index) in ContractEnum.states"
                      :key="index"
                      :value="rule.value"
                    >
                      {{ rule.description }}
                    </option>
                  </select>
                </div>
                <div class="four wide field upcoming-renewal-field">
                  <label>&nbsp;</label>
                  <div class="upcoming-renewal-checkbox-wrapper">
                    <div class="ui checkbox">
                      <input
                        type="checkbox"
                        id="contract-search-upcoming-renewal"
                        v-model="searchForm.upcomingRenewal"
                      />
                      <label for="contract-search-upcoming-renewal">
                        Completam ano este mês
                      </label>
                    </div>
                  </div>
                </div>
                <div class="end field">
                  <input
                    type="submit"
                    name="commit"
                    value="Filtrar"
                    class="ui button"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="row">
          <div class="sixteen wide column">
            <Grid
              ref="grid"
              resource="contracts"
              @refresh="search()"
              @page="n => search(n)"
            />
          </div>
        </div>
      </div>
    </template>
  </PageLayout>
</template>

<script>
import Api from '@/resources/Api';
import Breadcrumb from '@/components/breadcrumb';
import PageLayout from '@/layouts/page_layout';
// import Grid from '@/components/grid';
import Grid from './widgets/grid';
import ContractEnum from '@/enumerations/contract_enum';
import Feature from '@/utils/features';
import SearchMixins from '@/mixins/search_mixins';
import { mapGetters } from 'vuex';

export default {
  name: 'contracts',
  mixins: [SearchMixins],
  components: { Grid, Breadcrumb, PageLayout },

  computed: {
    ...mapGetters({
      paymentMethods: 'settings/paymentMethods'
    })
  },

  data() {
    return {
      ContractEnum: ContractEnum,
      enableCardNumber: Feature.allows('card_number'),
      plans: [],
      searchForm: {
        description: null,
        cod: null,
        card_number: null,
        state: null,
        member: null,
        plan_id: null,
        payment_method: null,
        upcomingRenewal: false
      },
      query: {}
    };
  },

  mounted() {
    this._initSearchForm();
    this.getPlans();
    this.search(this.$route.query.page);
    $('.ui.checkbox').checkbox();
  },

  methods: {
    getPlans() {
      this.loading = true;
      const query = {
        q: {
          s: ['id asc']
        }
      };

      Api.plans
        .search(query)
        .then(async response => {
          this.plans = _.clone(response.data.plans);
        })
        .catch(error => {
          this.$toast.show('Erro ao buscar dados de serviços', 'error');
          throw error;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    search(page = 1) {
      this._addSearchToQueryParams();

      const query = {
        q: {
          owner_cpf_or_owner_name_cont: this.searchForm.description,
          members_user_name_cont: this.searchForm.member,
          id_eq: this.searchForm.cod,
          card_number_eq: this.searchForm.card_number,
          plan_id_eq: this.searchForm.plan_id,
          payment_method_covenant_eq: this.searchForm.payment_method,
          s: ['created_at desc']
        },
        page: page
      };

      if (this.searchForm.state != null) {
        query.q.state_eq = this.searchForm.state;
      }

      if (this.searchForm.upcomingRenewal) {
        query.q.upcoming_renewal = 1;
      }

      this.$refs.grid.toggleLoading();
      Api.contracts
        .search(query)
        .then(async response => {
          this.$refs.grid.setData(
            response.data.contracts,
            response.data.pagination
          );
        })
        .catch(error => {
          this.$toast.show('Erro ao buscar dados', 'error');
          throw error;
        })
        .finally(() => {
          this.$refs.grid.toggleLoading();
        });
    }
  }
};
</script>

<style scoped>
.upcoming-renewal-field {
  display: flex;
  flex-direction: column;
}

.upcoming-renewal-checkbox-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
}
</style>
